export const BOOKING_RESERVATION_PAYLOAD_SESSION = "BOOKING_RESERVATION_PAYLOAD_SESSION"
export const BOOKING_QUESTION_PAYLOAD_SESSION = "BOOKING_QUESTION_PAYLOAD_SESSION"
